import { render } from "./ScrollableDataContainer.vue?vue&type=template&id=faa92000&scoped=true"
import script from "./ScrollableDataContainer.vue?vue&type=script&lang=js"
export * from "./ScrollableDataContainer.vue?vue&type=script&lang=js"

import "./ScrollableDataContainer.vue?vue&type=style&index=0&id=faa92000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa92000"]])

export default __exports__